// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yiF0","top":"styles_top__a9MyD","left":"styles_left__3Y_Ra","description":"styles_description__2H8OQ"};